export default "__VITE_ASSET__DSf0u8xv__"